export const USER_ROUTE = '/user';
export const USER_ACTION_ROUTE = `${USER_ROUTE}/action/:actionId`;
export const USER_ACTION_ALL_ROUTES = `${USER_ROUTE}/action*`;
